<template>
  <v-flex style="display: flex; border-bottom: 1px solid #eee" justify-start>
    <span style="width: 10%"></span>
    <v-tooltip top style="width: 10%">
      <v-icon slot="activator">view_module</v-icon>
      <span>Line Up</span>
    </v-tooltip>
    <div style="display: flex; flex-grow: 1">
      <f-flag
        :code="teams[lineup.noTeam].code"
        :height="20"
      ></f-flag>
      <div style="display: flex; flex-grow: 1; flex-direction: column">
        <div style="display: flex; align-items: center; justify-content: flex-start;">
          <span style="width: 5%">{{ players[lineup.noPlayer1].noShirt }}</span>
          <span style="width: 20%; text-align: left">{{ players[lineup.noPlayer1].volleyballPlayer.teamNamePlayer }}</span>
          <v-icon style="width: 7%">looks_one</v-icon>
        </div>
        <div style="display: flex; align-items: center; justify-content: flex-start;">
          <span style="width: 5%">{{ players[lineup.noPlayer2].noShirt }}</span>
          <span style="width: 20%; text-align: left">{{ players[lineup.noPlayer2].volleyballPlayer.teamNamePlayer }}</span>
          <v-icon style="width: 7%">looks_two</v-icon>
        </div>
        <div style="display: flex; align-items: center; justify-content: flex-start;">
          <span style="width: 5%">{{ players[lineup.noPlayer3].noShirt }}</span>
          <span style="width: 20%; text-align: left">{{ players[lineup.noPlayer3].volleyballPlayer.teamNamePlayer }}</span>
          <v-icon style="width: 7%">looks_3</v-icon>
        </div>
        <div style="display: flex; align-items: center; justify-content: flex-start;">
          <span style="width: 5%">{{ players[lineup.noPlayer4].noShirt }}</span>
          <span style="width: 20%; text-align: left">{{ players[lineup.noPlayer4].volleyballPlayer.teamNamePlayer }}</span>
          <v-icon style="width: 7%">looks_4</v-icon>
        </div>
        <div style="display: flex; align-items: center; justify-content: flex-start;">
          <span style="width: 5%">{{ players[lineup.noPlayer5].noShirt }}</span>
          <span style="width: 20%; text-align: left">{{ players[lineup.noPlayer5].volleyballPlayer.teamNamePlayer }}</span>
          <v-icon style="width: 7%">looks_5</v-icon>
        </div>
        <div style="display: flex; align-items: center; justify-content: flex-start;">
          <span style="width: 5%">{{ players[lineup.noPlayer6].noShirt }}</span>
          <span style="width: 20%; text-align: left">{{ players[lineup.noPlayer6].volleyballPlayer.teamNamePlayer }}</span>
          <v-icon style="width: 7%">looks_6</v-icon>
        </div>
      </div>
    </div>
  </v-flex>
</template>

<script>
import Flag from '@/components/Flag'

export default {
  props: ['lineup', 'teams', 'players'],

  components: {
    'f-flag': Flag,
  },
}
</script>




// WEBPACK FOOTER //
// src/components/MatchLive/PlayByPlay/LineUp.vue